import React from 'react';
import { CHART_TYPES } from '@/helpers/enums';
import { Radio } from '@mantine/core';
import PropTypes from 'prop-types';
import styles from './style.module.css';

const ChartType = (props) => {
  const {
    onChartTypeSelect = () => {},
  } = props;
  // eslint-disable-next-line no-unused-vars
  const chartTypesArray = Object.entries(CHART_TYPES).map(([_, typeValue]) => typeValue);

  return (
    <div>
      <Radio.Group
        onChange={(value) => onChartTypeSelect(value)}
        defaultValue={chartTypesArray[0]}
      >
        <div className={styles.radioButton}>
            {chartTypesArray.map((type, index) => (
              <React.Fragment key={type}>
                <Radio
                  value={type}
                  label={type}
                />
                {index < chartTypesArray.length - 1 && (
                  <span className={styles.divider}> | </span>
                )}
              </React.Fragment>
            ))}
        </div>
      </Radio.Group>
    </div>
  );
};

ChartType.propTypes = {
  onChartTypeSelect: PropTypes.func,
};

export default ChartType;
